import { TrackingService } from '@x/common/tracking/tracking.service';

export function initializeTracking(trackingService: TrackingService): Function {
  return (): Promise<boolean[]> => trackingService.initialize();
}
